namespace OccupationGroupConstants {
  export const DESCRIPTION_MAX_LENGTH = 6000;
  export const CODE_MAX_LENGTH = 256;
  export const PREFERRED_LABEL_MAX_LENGTH = 256;
  export const ALT_LABELS_MAX_ITEMS = 200;
  export const ALT_LABEL_MAX_LENGTH = 256;
  export const ORIGIN_URI_MAX_LENGTH = 4096;
  export const MAX_PATH_URI_LENGTH = 4096;
  export const MAX_TABIYA_PATH_LENGTH = 4096;
  export const UUID_HISTORY_MAX_ITEMS = 10000;
  export const MAX_UUID_HISTORY_ITEM_LENGTH = 36;
  export const DEFAULT_LIMIT = 10;
  export const MAX_LIMIT = 100;
  export const MAX_CURSOR_LENGTH = 1720;

  // The maximum length of the free-text search value (the `query` query parameter).
  export const SEARCH_VALUE_MAX_LENGTH = 256;

  // The maximum length of the (comma-separated) `searchFields` query parameter.
  export const SEARCH_FIELDS_MAX_LENGTH = 256;
}

export default OccupationGroupConstants;
